export default "__VITE_ASSET__227d64ce__"